/**
 * 体验项目管理api
 */
export default {
 
  // addProjectInfo:'/projectInfo/addProjectInfo',// 新增项目
  // deletedProjectInfo:'/projectInfo/deletedProjectInfo',// 删除
  // updateProjectInfo:'/projectInfo/updateProjectInfo',// 修改项目
  // saleStatusProjectInfo:'/projectInfo/updateSaleStatus',// 批量上下架/上下架
   
};
